export const DATE_STANDARD_FORMAT = 'YYYY-MM-DD';
export const DATE_VISUALIZE_FORMAT = 'DD-MM-YYYY';
export const TIME_STAMP = 'hh:mm:ss';
